import { Component } from '@cms-max/medicare-api-sdk'
import { SeoMetaData } from '@cms-max/cms-browser-api-client'

export const rxDrugCardSeoMetaData: SeoMetaData[] = [
  {
    path: '/rx-drug-card',
    component: Component.PrescriptionDrugCard,
    seo: {
      en: {
        title: `My prescription drug card information | Medicare`,
        description: ''
      },
      es: {
        title: ``,
        description: ''
      }
    }
  }
]
